// Shared helpers for calling the generated OpenAPI client from JS modules.
import { ApiError, OpenAPI } from "./generated";

const extractDetail = (error) => {
  if (!error) return "Request failed";
  if (typeof error?.body?.error === "string") return error.body.error;
  if (typeof error?.body?.detail === "string") return error.body.detail;
  if (typeof error?.body?.message === "string") return error.body.message;
  if (typeof error?.message === "string") return error.message;
  return "Request failed";
};

/**
 * Normalize generated client errors so existing callers can read detail/fieldErrors/status.
 * @param {unknown} error
 */
export const normalizeApiError = (error) => {
  if (error instanceof ApiError) {
    const normalized = new Error(extractDetail(error));
    normalized.status = error.status;
    normalized.code = error?.body?.code;
    const details = error?.body?.details;
    const detailFieldErrors = details && typeof details === "object" && !Array.isArray(details) ? details : {};
    normalized.fieldErrors = error?.body?.field_errors || detailFieldErrors || {};
    return normalized;
  }
  if (error?.response?.data) {
    const detail =
      error?.response?.data?.error ||
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      error?.message ||
      "Request failed";
    const normalized = new Error(detail);
    normalized.status = error?.response?.status;
    normalized.code = error?.response?.data?.code;
    const details = error?.response?.data?.details;
    const detailFieldErrors = details && typeof details === "object" && !Array.isArray(details) ? details : {};
    normalized.fieldErrors = error?.response?.data?.field_errors || detailFieldErrors || {};
    return normalized;
  }
  return error instanceof Error ? error : new Error("Request failed");
};

/**
 * Wrap a generated client promise and return axios-like { data } shape.
 * @template T
 * @param {Promise<T>} promise
 * @returns {Promise<{ data: T }>}
 */
export const withApi = async (promise) => {
  try {
    const data = await promise;
    return { data };
  } catch (error) {
    throw normalizeApiError(error);
  }
};

/**
 * Return plain data while still normalizing errors.
 * @template T
 * @param {Promise<T>} promise
 * @returns {Promise<T>}
 */
export const withApiData = async (promise) => {
  const { data } = await withApi(promise);
  return data;
};

export { ApiError, OpenAPI };
